import { useState } from "react";
import { Switch, Spin } from "antd";
import "firebase/compat/firestore";
import { Container, Card, CardBody, Row, Col } from "reactstrap";
import ShowingMfgDetails from "../../components/cards/ShowingMfgDetails";
import { CustomerDropdown } from "../../components/dropdown/DropDown";
import TransferConfirmationModal from "../../components/modals/TransferConfirmationModal";
import ProductsOfMfg from "../../components/table/ProductsOfMfg";
import useMfgDetails from "./customHooks/useMfgDetails";
import CreateNewItem from "../../components/modals/CreateNewItem";
import { stringifySpecs } from "../../firebase/utility";
import { FiShuffle, FiSettings } from "react-icons/fi";
const ManufacturerDetails = () => {
    const {
        details,
        products,
        loadingProducts,
        totalItems,
        page,
        setPage,
        pageSize,
        setPageSize,
        handleManufacturerSearch,
        handleMfg,
        selectedManufacturer,
        modal,
        setModal,
        handleLink,
        handleTransfer,
        getPartNumber,
        history, searchedMfg,
        all_manufacturers,
        dataLoading,
        isLoading,
        fetchProducts,
    } = useMfgDetails();

    const [createItemModal, setCreateItemModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [newItem, setNewItem] = useState({
        sku: "TMU-",
        vendor_part: "",
        item_mfg_part: "",
        item_upc: "",
        mfg_name: "",
        productType: "",
        mfg_com_group: "",
        mfg_condition: "",
        item_title: "",
        description: "",
        long_description: "",
        item_specification: "",
        stc_quantity: 0,
        stc_markup: "",
        stc_map: "",
        stc_cost: 0,
        stc_price: 0,
        stc_MSRP: "",
        height: 0,
        length: 0,
        width: 0,
        weight: 0,
        data_created: new Date(),
        imageUrl: "",
        id: "",
        category: {},
        subCategory: {},
        updatePriceFromDnh: true,
        showPriceToGuests: false,
        hidePriceFromGuests: false,
    });

    const toggleCreateModal = () => setCreateItemModal(!createItemModal);

    const handleEditProduct = (p) => {
        setSelectedProduct(p);
        setNewItem({
            vendor_part: p?.vendor_part ?? "",
            item_mfg_part: p?.item_mfg_part ?? "",
            item_upc: p?.item_upc ?? "",
            mfg_name: p?.mfg_name ?? "",
            productType: p?.productType ?? "",
            mfg_com_group: p?.mfg_com_group ?? "",
            mfg_condition: p?.mfg_condition ?? "",
            item_title: p?.name ?? "",
            description: p?.description ?? "",
            long_description: p?.long_description ?? "",
            item_specification: (p?.item_specification && typeof p.item_specification === 'object')
                ? stringifySpecs(p.item_specification)
                : (p?.item_specification ?? ""),
            stc_quantity: p?.stc_quantity ?? "",
            stc_markup: p?.stc_markup ?? "",
            stc_map: p?.stc_map ?? "",
            stc_cost: p?.stc_cost ?? "",
            price: p?.price ?? "",
            stc_MSRP: p?.stc_MSRP ?? "",
            height: p?.dimensions?.height ?? 0,
            length: p?.dimensions?.length ?? 0,
            width: p?.dimensions?.width ?? 0,
            weight: p?.weight ?? 0,
            data_created: new Date(),
            imageUrl: p?.imageUrl ?? "",
            sku: p?.sku ?? "TMU-",
            id: p?.id ?? "",
            category: p?.category ?? {},
            subCategory: p?.subCategory ?? {},
            updatePriceFromDnh: p?.updatePriceFromDnh ?? true,
            showPriceToGuests: p?.showPriceToGuests ?? false,
            hidePriceFromGuests: p?.hidePriceFromGuests ?? false,
        });
        setCreateItemModal(true);
    };

    if (isLoading) {
        return (
            <div className="settings-container d-flex align-items-center justify-content-center" style={{ height: '80vh' }}>
                <div className="text-center p-5 bg-white rounded-3 shadow-sm border">
                    <Spin size="large" className="mb-4" />
                    <h5 className="fw-bold text-dark mb-1">Manufacturer Transfer in Progress</h5>
                    <p className="text-muted small mb-0">Processing data migration, please wait...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="settings-container">
            {modal && (
                <TransferConfirmationModal
                    modal={modal}
                    toggle={() => setModal(!modal)}
                    handleTransfer={handleTransfer}
                />
            )}

            <div className="px-4 pb-5">
                {/* Manufacturer Details Card Component */}
                <ShowingMfgDetails details={details} handleLink={handleLink} history={history} />

                {/* Configuration & Actions Row */}
                <Row className="gy-4 mb-4">
                    <Col lg={4}>
                        <Card className="settings-card shadow-sm border-0 h-100 mt-0">
                            <CardBody className="p-4">
                                <h5 className="section-title mb-4">
                                    <FiSettings className="me-2" /> Display Settings
                                </h5>
                                <div className="d-flex align-items-center justify-content-between p-3 bg-light rounded-3 mb-3">
                                    <span className="text-dark fw-500">MAP Protected</span>
                                    <Switch checked={details?.map} disabled />
                                </div>
                                <div className="d-flex align-items-center justify-content-between p-3 bg-light rounded-3">
                                    <span className="text-dark fw-500">Display</span>
                                    <Switch checked={details?.display} disabled />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg={8}>
                        <Card className="settings-card shadow-sm border-0 h-100 mt-0">
                            <CardBody className="p-4">
                                <h5 className="section-title mb-4">
                                    <FiShuffle className="me-2" /> Bulk Product Transfer
                                </h5>
                                <p className="text-muted small mb-4">Transfer all products from this manufacturer to another entity. This action is permanent and will move the entire inventory.</p>
                                <div className="transfer-dropdown-wrapper">
                                    <CustomerDropdown
                                        width={"100%"}
                                        label={"Target Manufacturer"}
                                        placeholder={"Search and select manufacturer..."}
                                        showSearch
                                        object_key={"mfg"}
                                        options={searchedMfg?.length > 0 ? searchedMfg : all_manufacturers}
                                        value={selectedManufacturer?.name}
                                        onSearch={handleManufacturerSearch}
                                        onSelect={(value) => {
                                            handleMfg(value);
                                        }}
                                        loading={dataLoading}
                                        customClassName={"mfg_input mb-1 w-100 rounded-3"}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Products Table Component */}
                <ProductsOfMfg
                    loadingProducts={loadingProducts}
                    products={products}
                    getPartNumber={getPartNumber}
                    page={page}
                    totalItems={totalItems}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onEdit={handleEditProduct}
                />
            </div>

            {createItemModal && (
                <CreateNewItem
                    modal={createItemModal}
                    toggle={toggleCreateModal}
                    newItem={newItem}
                    setNewItem={setNewItem}
                    productSlug={selectedProduct?.slug}
                    gettingProducts={fetchProducts}
                />
            )}
        </div>
    );
};

export default ManufacturerDetails;
